export const paths = {
  home: '/',
  auth: { signIn: '/login', signup: '/signUp', logout: '/logout', resetPassword: '/reset-password' },
  admin: {
    home: '/admin/home',
    users: '/admin/users',
    newUser: '/admin/users/new',
    viewUser: '/admin/users/view',
    editBusinessBase: '/admin/users/editbase',
    companies: '/admin/companies',
    newCompany: '/admin/companies/new',
    viewCompany: '/admin/companies/view',
    editCompanyBase: '/admin/companies/editbase',
    agents: '/admin/agents',
    newAgent: '/admin/agents/new',
    viewAgent: '/admin/agents/view',
    agentBusinesses: '/admin/agents/business/view',
    assessment: '/admin/assessments',
    newAssessment: '/admin/assessments/new',
    updateAssessment: '/admin/assessments/update',
    assessmentDetails: '/admin/assessments/details',
    assessmentForm: '/admin/assessment/form',
    program: '/admin/programs',
    programForm: '/admin/programs/update',
    programDetails: '/admin/programs/details',
    workflowForm: '/admin/workflows/new',
    activities: '/admin/activities',
    subscriptions: '/admin/subscriptions',
    payments: '/admin/payments',
    profile: '/admin/profile',
    settings: '/admin/settings',
    workflows: '/admin/workflows',
    workflowView: '/admin/workflow/view',
    assignWorkflow: '/admin/workflow/subscribe',
  },
  agent: {
    home: '/agent/home',
    clients: '/agent/clients',
    clientDetail: '/agent/clients/view',
    workflows: '/agent/workflows',
    activities: '/agent/activities',
    settings: '/agent/settings',
    companyProfile: '/agent/company/profile',
    companyEditServiceInfo: '/agent/company/editServiceInfo',
    companyAgents: '/agent/company/agents',
    companyAgentView: '/agent/company/agents/view',
    companyPlatformSubscription: '/agent/company/platformSubscriptions',
    companySubscriptionDetails: '/agent/company/subscriptionDetails',
    profile: '/agent/profile',
    payments: '/agent/payments',
    support: '/agent/support',
    assessmentView: '/agent/assessment/view',
    assessmentForm: '/agent/assessment/form',
    assessmentDetails: '/agent/assessment/details',
    workflowView: '/agent/workflow/view',
    assignWorkflow: '/agent/workflow/subscribe',
  },
  business: {
    home: '/business/home',
    settings: '/business/settings',
    profile: '/business/profile',
    support: '/business/support',
    subscriptions: '/business/subscriptions',
    workflows: '/business/workflows',
    assessmentView: '/business/assessment/view',
    assessmentForm: '/business/assessment/form',
    assessmentDetails: '/business/assessment/details',
    subscribeWorkflow: '/business/workflow/subscribe',
    workflowView: '/business/workflow/view',
    payments: '/business/payments',
    editCorporateProfile: '/business/profile/edit',
  },
  common: {
    assessmentForm: '/assessment/form',
    assessmentDetails: '/assessment/details',
    subscribeWorkflow: '/workflow/subscribe',
    workflowView: '/workflow/view',
  },
  errors: { notFound: '/errors/not-found' },
} as const;